import * as types from '../constants/ActionTypes';

export const setExpediente = expediente => dispatch => {
  dispatch({
    type: types.SET_EXPEDIENTE,
    payload: {
      expediente,
    },
  });
};

export const agregarActuacion = actuacion => dispatch => {
  dispatch({
    type: types.ADD_ACTUACION,
    payload: {
      actuacion,
    },
  });
};

export const agregarRecibo = recibo => dispatch => {
  dispatch({
    type: types.ADD_RECIBO,
    payload: {
      recibo,
    },
  });
};

export const actualizarActuacion = actuacion => dispatch => {
  dispatch({
    type: types.UPDATE_ACTUACION,
    payload: {
      actuacion,
    },
  });
};
export const actualizarContraventor = contraventor => dispatch => {
  dispatch({
    type: types.UPDATE_CONTRAVENTOR_EXPEDIENTE,
    payload: {
      contraventor,
    },
  });
};

export const actualizarEstado = estado => dispatch => {
  dispatch({
    type: types.UPDATE_ESTADO_EXPEDIENTE,
    payload: {
      estado,
    },
  });
};
